export default {
  header: {
    logo: 'Vuejs',
    home: '首页',
    examples: '演示',
    documents: '文档',
    blog: 'Blog',
    locale: 'Language(语言)',
    issues: 'Issues',
    github: 'Github',
  },

  locale: {
    en: 'English',
    'zh-cn': '中文(简体)',
  },

  document: {
    title: '文档',
  },


  example: {
    full: '完整例子',
    simple: '简单例子',
    avatar: '上传头像',
    drag: '拖拽上传',
    multiple: '多个实例',
    vuex: 'Vuex',
  }
}
